<script lang="ts" generics="ITEM">
    import type {SearchParams, Sorting, ViewableSearch} from 'src/typings';
    import type {Observable} from 'rxjs';
    import {getSearchContext} from '../kp-search-context/search-context';
    import {findFirst, byId} from 'shared/utils/array-utils';
    import {exists} from 'shared/utils/custom-utils';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import SearchToolbarSection from './SearchToolbarSection.svelte';

    const searchManager = getSearchContext<ITEM>();
    $: hasAnySortings = exists($lastSearch) && $lastSearch.features && $lastSearch.features.includes('sorting') && $lastSearch.availableSortings.length > 1;

    let lastSearch: Observable<ViewableSearch<SearchParams, ITEM>>;
    $: lastSearch = searchManager.getLastSearch$();

    let selectedSorting: Sorting;
    $: if (exists($lastSearch) && exists(searchManager.getFrontendParams()?.sorting)) {
        let searchedId = searchManager.getFrontendParams().sorting.id;
        if (typeof searchManager.getFrontendParams().sorting === 'string') {
            searchedId = searchManager.getFrontendParams().sorting as any as string; // TODO: clean this shit up, tohle je hrůza děs- skoro jsem až dostal raka, když jsem to psal... ty frontend parametry se nějak stringifikují na sorting: <string>, i když tam nastavuju vyloženě sorting object
        }

        selectedSorting = findFirst($lastSearch.availableSortings, byId(searchedId));
    }

    function onSortingChange(sorting: Sorting) {
        searchManager.newSearchWithPartialParams({sorting});
    }
</script>

{#if hasAnySortings}
    <SearchToolbarSection icon="list" title="Řazení dle">
        {#each $lastSearch.availableSortings as sorting}
            <button class="sorting-item"
                    on:click={() => onSortingChange(sorting)}
                    class:sorting-selected={sorting?.id === selectedSorting?.id}>

                {pipe(sorting, loc())}
            </button>
        {/each}
    </SearchToolbarSection>
{/if}

<style lang="less">
    .sorting-item {
        padding: 0;
        margin: 0;
        background: none;
        border: none;
        outline: none;
        cursor: pointer;

        &.sorting-selected {
            font-weight: 500;
            text-decoration: underline;
            color: var(--accent-blue);
        }
    }
</style>